import template from './alphabetical-filter.html';
import controller from './alphabetical-filter.controller';
import './alphabetical-filter.scss';

export default {
  template,
  controller,
};



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/members/screens/member-list/components/alphabetical-filter/index.js